import { useEffect, useRef } from 'react';
import { trackEvent } from '../../analytics/sml/analytics';
import type { DirectedScreen } from '../directedSteps';

const EVENT_STEP = {
  cast: 'cast',
  stories: 'stories',
  style: 'style',
  script: 'script',
  price: 'price',
  progress: 'make',
} as const;

type EventStep = (typeof EVENT_STEP)[keyof typeof EVENT_STEP];

const stepOf = (screen: DirectedScreen | null): EventStep | null =>
  screen === null || screen === 'failed' || screen === 'cancelled' ? null : EVENT_STEP[screen];

/**
 * `directed_video_step` for each step on screen, and `directed_video_closed` when the wizard goes:
 * `confirmed` once the make runs, else `abandoned`.
 */
export function useDirectedVideoEvents(screen: DirectedScreen | null): void {
  const step = stepOf(screen);
  const last = useRef<EventStep | null>(null);
  useEffect(() => {
    if (step === null) {
      return;
    }
    last.current = step;
    trackEvent('directed_video_step', { step });
  }, [step]);
  useEffect(
    () => () => {
      if (last.current !== null) {
        trackEvent('directed_video_closed', {
          step: last.current,
          result: last.current === 'make' ? 'confirmed' : 'abandoned',
        });
      }
    },
    []
  );
}
